import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid } from "@mui/material";
import FaqCustomerAccordian from "./FaqCustomerAccordian";
import Loader from "components/loader/Loader";

function FaqTabSection(props) {
  const { accordianData, handleChange, value, faqSectionLoader } = props;
  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle marginBlock10">
          <TabContext value={value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  xs={6}
                >
                  <Tab label="Customer" value="Customer" className="tabStyle" />
                  <Tab label="Driver" value="Driver" className="tabStyle" />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="Customer" className="tabPanelStyle">
              {faqSectionLoader ? (
                <Loader />
              ) : (
                <FaqCustomerAccordian accordianData={accordianData} />
              )}
            </TabPanel>
            <TabPanel value="Driver" className="tabPanelStyle">
              {faqSectionLoader ? (
                <Loader />
              ) : (
                <FaqCustomerAccordian accordianData={accordianData} />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FaqTabSection;
